var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosedGigs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "17pt",
    height: "17pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#595757",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295 895 c-21 -20 -25 -34 -25 -85 l0 -60 -104 0 c-153 0 -146 16 -146 -314 1 -189 4 -265 13 -277 29 -37 47 -39 439 -39 378 0 384 1 422 23 22 12 53 39 70 60 28 35 31 47 34 115 3 95 -19 142 -90 187 l-47 30 0 83 c-1 74 -4 85 -26 107 -22 23 -31 25 -125 25 l-100 0 0 60 c0 51 -4 65 -25 85 -23 24 -30 25 -145 25 -115 0 -122 -1 -145 -25z m475 -295 c0 -48 -3 -60 -15 -60 -45 0 -125 -63 -156 -122 -23 -44 -25 -132 -4 -168 8 -14 14 -28 15 -32 0 -5 -112 -8 -250 -8 l-250 0 0 225 0 225 330 0 330 0 0 -60z m109 -137 c71 -53 91 -139 49 -214 -42 -75 -158 -102 -227 -52 -31 23 -71 97 -71 133 0 14 10 46 23 70 41 83 156 115 226 63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697 423 c-16 -16 -15 -19 20 -55 l37 -38 -39 -40 c-38 -39 -38 -40 -19 -55 26 -20 26 -20 64 20 l34 35 38 -37 c31 -30 40 -34 53 -23 22 18 19 27 -21 62 l-35 31 35 36 c41 42 42 46 20 68 -14 14 -19 12 -53 -21 l-37 -36 -34 35 c-39 40 -40 41 -63 18z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedGigs);
export default __webpack_public_path__ + "static/media/ClosedGigs.c303193c.svg";
export { ForwardRef as ReactComponent };